module.exports = __webpack_public_path__ + "images/aspireeda05eb4cf9af615d07b9691473ac950.png";